<!-- 任务书图标 -->
<template>
  <svg
    t="1748246575519"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="13899"
    width="200"
    height="200"
  >
    <path
      d="M144 160m128 0l480 0q128 0 128 128l0 528q0 128-128 128l-480 0q-128 0-128-128l0-528q0-128 128-128Z"
      fill="#FFFFFF"
      p-id="13900"
    />
    <path
      d="M192 208m112 0l448 0q112 0 112 112l0 496q0 112-112 112l-448 0q-112 0-112-112l0-496q0-112 112-112Z"
      fill="#82DAFA"
      p-id="13901"
    />
    <path
      d="M752 960H272c-79.4 0-144-64.6-144-144V288c0-79.4 64.6-144 144-144h480c79.4 0 144 64.6 144 144v528c0 79.4-64.6 144-144 144zM272 176a112.12 112.12 0 0 0-112 112v528a112.12 112.12 0 0 0 112 112h480a112.12 112.12 0 0 0 112-112V288a112.12 112.12 0 0 0-112-112z"
      fill="#333333"
      p-id="13902"
    />
    <path
      d="M320 448m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z"
      fill="#FFFFFF"
      p-id="13903"
    />
    <path
      d="M320 704m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z"
      fill="#FFFFFF"
      p-id="13904"
    />
    <path
      d="M336 720m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z"
      fill="#FF9580"
      p-id="13905"
    />
    <path
      d="M336 464m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z"
      fill="#FF9580"
      p-id="13906"
    />
    <path
      d="M320 512a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64z m0-96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM320 768a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64z m0-96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM752 464H496a16 16 0 0 1 0-32h256a16 16 0 0 1 0 32zM736 736H512a32 32 0 0 1 0-64h224a32 32 0 0 1 0 64z"
      fill="#333333"
      p-id="13907"
    />
    <path
      d="M288 80m48 0l352 0q48 0 48 48l0 64q0 48-48 48l-352 0q-48 0-48-48l0-64q0-48 48-48Z"
      fill="#FFFFFF"
      p-id="13908"
    />
    <path
      d="M336 128m32 0l320 0q32 0 32 32l0 32q0 32-32 32l-320 0q-32 0-32-32l0-32q0-32 32-32Z"
      fill="#CC87FA"
      p-id="13909"
    />
    <path
      d="M688 256H336a64.07 64.07 0 0 1-64-64v-64a64.07 64.07 0 0 1 64-64h352a64.07 64.07 0 0 1 64 64v64a64.07 64.07 0 0 1-64 64zM336 96a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h352a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32z"
      fill="#333333"
      p-id="13910"
    />
  </svg>
</template>
